//@ts-nocheck
import { ChakraProvider, LightMode } from "@chakra-ui/react";
import { css, Global } from "@emotion/react";
import React from "react";
import theme from "./theme";

import "@fontsource/sora/800.css";
import "@fontsource/sora/700.css";
import "@fontsource/sora/600.css";
import "@fontsource/sora/500.css";
import "@fontsource/sora/400.css";
import "@fontsource/sora/300.css";
import "@fontsource/sora/200.css";
import "@fontsource/sora/100.css";
import "@fontsource/shantell-sans/300.css";
import "@fontsource/shantell-sans/400.css";
import "@fontsource/shantell-sans/500.css";
import "@fontsource/shantell-sans/600.css";
import "@fontsource/shantell-sans/700.css";
import "@fontsource/shantell-sans/800.css";
import ErrorBoundary from "./Errorboundary";

export const GlobalFonts = css`
  @font-face {
    font-family: Larsseit;
    src:
      url("/static/fonts/Larsseit/Larsseit-Medium.woff") format("woff"),
      url("/static/fonts/Larsseit/Larsseit-Medium.eot") format("eot"),
      url("/static/fonts/Larsseit/Larsseit-Medium.ttf") format("truetype");
    font-weight: 700;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: Larsseit;
    src:
      url("/static/fonts/Larsseit/Larsseit-Bold.woff") format("woff"),
      url("/static/fonts/Larsseit/Larsseit-Bold.eot") format("eot"),
      url("/static/fonts/Larsseit/Larsseit-Bold.ttf") format("truetype");
    font-weight: 800;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: Larsseit;
    src:
      url("/static/fonts/Larsseit/Larsseit.woff") format("woff"),
      url("/static/fonts/Larsseit/Larsseit.eot") format("eot"),
      url("/static/fonts/Larsseit/Larsseit.ttf") format("truetype");
    font-weight: 500;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: "Inter";
    src:
      url("/static/fonts/Inter/Inter-Regular.woff") format("woff"),
      url("/static/fonts/Inter/Inter-Regular.ttf") format("truetype");
    font-weight: 400;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: "Inter";
    src:
      url("/static/fonts/Inter/Inter-Medium.woff") format("woff"),
      url("/static/fonts/Inter/Inter-Medium.ttf") format("truetype");
    font-weight: 500;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: "Inter";
    src:
      url("/static/fonts/Inter/Inter-SemiBold.woff") format("woff"),
      url("/static/fonts/Inter/Inter-SemiBold.ttf") format("truetype");
    font-weight: 600;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: "Inter";
    src:
      url("/static/fonts/Inter/Inter-Bold.woff") format("woff"),
      url("/static/fonts/Inter/Inter-Bold.ttf") format("truetype");
    font-weight: 700;
    font-style: normal;
    font-display: fallback;
  }

  :root {
    --chakra-fonts-cursive: "Shantell Sans", sans-serif;
    --chakra-fonts-heading: "Sora", sans-serif;
    --font-shantell-sans: "Shantell Sans", sans-serif;
    --font-sora: "Sora", sans-serif;
  }
`;

export const GlobalStyle = css`
  @font-face {
    font-family: Larsseit;
    src:
      url("/static/fonts/Larsseit/Larsseit-Medium.eot") format("eot"),
      url("/static/fonts/Larsseit/Larsseit-Medium.ttf") format("truetype"),
      url("/static/fonts/Larsseit/Larsseit-Medium.woff") format("woff");
    font-weight: 700;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: Larsseit;
    src:
      url("/static/fonts/Larsseit/Larsseit-Bold.eot") format("eot"),
      url("/static/fonts/Larsseit/Larsseit-Bold.ttf") format("truetype"),
      url("/static/fonts/Larsseit/Larsseit-Bold.woff") format("woff");
    font-weight: 800;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: Larsseit;
    src:
      url("/static/fonts/Larsseit/Larsseit.eot") format("eot"),
      url("/static/fonts/Larsseit/Larsseit.woff") format("woff"),
      url("/static/fonts/Larsseit/Larsseit.ttf") format("truetype");
    font-weight: 500;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: "Inter";
    src:
      url("/static/fonts/Inter/Inter-Regular.ttf") format("truetype"),
      url("/static/fonts/Inter/Inter-Regular.woff") format("woff");
    font-weight: 400;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: "Inter";
    src:
      url("/static/fonts/Inter/Inter-Medium.ttf") format("truetype"),
      url("/static/fonts/Inter/Inter-Medium.woff") format("woff");
    font-weight: 500;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: "Inter";
    src:
      url("/static/fonts/Inter/Inter-SemiBold.ttf") format("truetype"),
      url("/static/fonts/Inter/Inter-SemiBold.woff") format("woff");
    font-weight: 600;
    font-style: normal;
    font-display: fallback;
  }

  @font-face {
    font-family: "Inter";
    src:
      url("/static/fonts/Inter/Inter-Bold.ttf") format("truetype"),
      url("/static/fonts/Inter/Inter-Bold.woff") format("woff");
    font-weight: 700;
    font-style: normal;
    font-display: fallback;
  }

  html,
  body {
    font-family: ${theme.fonts.body};
    font-weight: ${theme.fontWeights.normal};
    font-size: ${theme.fontSizes.md};
    color: ${theme.colors.gray["500"]};
    line-height: ${theme.lineHeights.normal};
    -webkit-font-smoothing: antialiased;
  }

  * {
    box-sizing: border-box;
  }

  .pac-container {
    font-family: ${theme.fonts.body};
    font-size: ${theme.fontSizes.md};
    border-radius: ${theme.borderRadius.regular};
  }

  .pac-container .pac-item .pac-icon {
    background-image: none;
    display: none;
  }

  .pac-container .pac-item {
    color: ${theme.colors.gray["500"]} !important;
    padding: 8px 16px;
    font-size: ${theme.fontSizes.md};
    font-weight: ${theme.fontWeights.normal};
    border: none;

    &:hover {
      background-color: ${theme.colors.gray["200"]};
      cursor: pointer;
    }

    &.pac-item-selected {
      background-color: ${theme.colors.gray["200"]};
    }

    .pac-item-query {
      font-size: ${theme.fontWeights.normal};
      padding-right: 3px;
      color: ${theme.colors.gray["500"]};
    }

    .pac-matched {
      font-weight: ${theme.fontWeights.medium};
    }
  }

  .pac-logo {
    &:after {
      display: none;
    }
  }
  .chakra-checkbox__control {
    border-color: rgb(227, 231, 237);
  }
`;

const ZetaProvider: React.FC<{
  children: React.ReactNode;
  onError?: (error: Error, componentStack: string) => void;
  errorLayout?: React.ReactNode;
  ignore?: boolean;
  useLascodaErrorPage?: boolean;
}> = ({ children, onError, ignore, errorLayout, useLascodaErrorPage }) => {
  if (!ignore) {
    return (
      <ChakraProvider theme={theme}>
        <Global styles={GlobalFonts} />
        <LightMode>
          <ErrorBoundary
            ignore={ignore}
            processError={onError}
            errorComponent={errorLayout}
            useLascodaErrorPage={useLascodaErrorPage}
          >
            {children}
          </ErrorBoundary>
        </LightMode>
      </ChakraProvider>
    );
  }
  return (
    <ChakraProvider theme={theme}>
      <Global styles={GlobalFonts} />
      <LightMode>{children}</LightMode>
    </ChakraProvider>
  );
};
export default ZetaProvider;
